'use strict';

var _inherits = require('babel-runtime/helpers/inherits')['default'];

var _classCallCheck = require('babel-runtime/helpers/class-call-check')['default'];

var _interopRequireDefault = require('babel-runtime/helpers/interop-require-default')['default'];

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var _components = {
	_$ModalWindowContainer: {
		displayName: 'ModalWindowContainer'
	}
};

function _wrapComponent(uniqueId) {
	return function (ReactClass) {
		return ReactClass;
	};
}

var ModalWindowContainer = (function (_React$Component) {
	_inherits(ModalWindowContainer, _React$Component);

	function ModalWindowContainer() {
		_classCallCheck(this, _ModalWindowContainer);

		_React$Component.apply(this, arguments);
	}

	ModalWindowContainer.prototype.render = function render() {
		return _react2['default'].createElement(
			'span',
			null,
			this.props.windows.map(function (item) {
				return _react2['default'].createElement(
					'span',
					{ key: item.id },
					item.modal
				);
			})
		);
	};

	var _ModalWindowContainer = ModalWindowContainer;
	ModalWindowContainer = _wrapComponent('_$ModalWindowContainer')(ModalWindowContainer) || ModalWindowContainer;
	ModalWindowContainer = _reactRedux.connect(function (state) {
		return {
			windows: state.modals
		};
	})(ModalWindowContainer) || ModalWindowContainer;
	return ModalWindowContainer;
})(_react2['default'].Component);

exports['default'] = ModalWindowContainer;
;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/reactis/reactis-modal/src/ModalWindowContainer.js
 ** module id = 1027
 ** module chunks = 1
 **/